import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import {upload} from '../upload_actions';
import UploadBox from './UploadBox';
import {constants, utils} from 'src/js/common';

const logger = utils.LogUtils.getLogger(
  'UploadContainer',
  constants.LIBRARY_NAME
);

class UploadContainer extends React.Component {
  constructor() {
    super();

    this.uploadFiles = this.uploadFiles.bind(this);
  }

  uploadFiles(acceptedFiles, rejectedFiles) {
    const {config, stateId} = this.props;
    if (acceptedFiles && acceptedFiles.length > 0) {
      // just collect file names to the fileIds property
      const fileIDs = acceptedFiles.map((file) => file.name || '');
      // upload files
      this.props.upload(stateId, config.service.url.upload, {
        files: acceptedFiles,
        fileIDs,
      });
    }
    if (rejectedFiles && rejectedFiles.length > 0) {
      const fileNames = rejectedFiles.map((file) => file.name || '').join(', ');
      logger.log(`Some files were rejected: ${fileNames}`);
    }
  }

  render() {
    const {isUploadingCounter, isUploadSuccessful, uploadedFiles} = this.props;
    return (
      <UploadBox
        isUploadingCounter={isUploadingCounter}
        isUploadSuccessful={isUploadSuccessful}
        uploadedFiles={uploadedFiles}
        handleUpload={this.uploadFiles}
      />
    );
  }
}

UploadContainer.displayName = 'UploadContainer';

UploadContainer.propTypes = {
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  stateId: PropTypes.string.isRequired,
};

export default connect(
  (state, props) => ({
    isUploadingCounter: state[props.stateId].isUploadingCounter,
    isUploadSuccessful: state[props.stateId].isUploadSuccessful,
    uploadedFiles: state[props.stateId].uploadedFiles,
  }),
  {
    upload,
  }
)(UploadContainer);
